import { render } from "./medicineAboutSection.vue?vue&type=template&id=768ba748&scoped=true"
import script from "./medicineAboutSection.vue?vue&type=script&lang=js"
export * from "./medicineAboutSection.vue?vue&type=script&lang=js"

import "./medicineAboutSection.vue?vue&type=style&index=0&id=768ba748&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768ba748"]])

export default __exports__